<template>
  <div class="container">
    <div style="border: solid 1px #c9cbd6">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%; min-width: 1000px"
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <el-table-column label="订单编号" prop="order_sn"></el-table-column>
        <el-table-column label="下单时间" prop="create_time"></el-table-column>
        <el-table-column
          label="订单金额(含运费)"
          prop="pay_money"
        ></el-table-column>
        <el-table-column label="商品金额" prop="goods_price"></el-table-column>
        <el-table-column
          label="会员优惠"
          prop="discount_price"
        ></el-table-column>
        <el-table-column
          label="优惠券优惠"
          prop="discount_price"
        ></el-table-column>
        <el-table-column
          label="活动优惠"
          prop="discount_price"
        ></el-table-column>
        <el-table-column label="交易状态">
          <template slot-scope="scope">
            <span>{{ scope.row.status | filterStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="toDetail(scope.row)"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('788') : false
              "
              type="text"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align: center">
      <pagination
        v-show="totalNum > 0"
        :total="totalNum"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getLogList"
      />
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import Pagination from "@/components/Pagination/index.vue";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tableData: [],
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      discountPriceTotal: "",
      discountPriceSurplus: "",
    };
  },
  filters: {
    filterStatus(val) {
      switch (val) {
        case 1:
          return "待付款";
        case 2:
          return "待发货";
        case 3:
          return "待收货";
        case 4:
          return "已完成";
        case 5:
          return "已取消[超时未支付]";
        case 6:
          return "已取消[用户取消]";
        case 7:
          return "已取消[超时未发货]";
        case 8:
          return "用户申请退款";
        case 9:
          return "商户取消";
        case 10:
          return "拼团未成功取消";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取列表
    getLogList() {
      let params = Object.assign(
        {
          user_id: this.$route.query.user_id,
        },
        this.pagination
      );
      this.axios
        .post("platform/shop/getUserOrderList", params)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = platform.timestampToTime(item.create_time);
              return item;
            });
            this.discountPriceTotal = res.data.discountPriceTotal;
            this.discountPriceSurplus = res.data.discountPriceSurplus;
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toDetail(row) {
      let { order_id, card_price, integral_price } = row;
      let order_type = 0;
      if (integral_price > 0) {
        order_type = 1;
      } else if (card_price > 0) {
        order_type = 2;
      } else {
        order_type = 0;
      }
      this.$router.push({
        path: "/home/shoppingmall/orderdetail?order_id=7429&order_type=0",
        query: { order_id, order_type },
      });
    },
  },
  created() {
    this.getLogList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: left;
  padding: 20px;
  box-sizing: border-box;
}
</style>
